import { CliniciansView } from "@/features/admin/clinicians/components/CliniciansView";

export function CliniciansPage() {
  return <CliniciansView />;
}
